import { useQuery } from "@tanstack/react-query";
import { getAgentWantAdList } from "@/services/agentClientsService";

const REQUEST_SCAN_LIMIT = 50;

export const useFormRequests = (onlySyndicatedListings) =>
  useQuery({
    queryKey: ["agentWantAds", "formRequests", { onlySyndicatedListings }],
    queryFn: async () => {
      const response = await getAgentWantAdList({
        sortBy: "date",
        sortDir: "desc",
        page: 1,
        limit: REQUEST_SCAN_LIMIT,
        status: "draft",
        onlySyndicatedListings,
      });
      if (response?.errorCode !== 0) return [];
      return response?.result || [];
    },
  });
